import { listen } from '../../../CodesThatsGottaGoSomewhereElse';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { ObjectManager } from '../../../concepts/objects';
import { Point } from '../../../platform/geom/Point';
import { Colors } from '../../../ui';
import { ActiveObject, resolve } from '../../Container';
import { EditorOptions } from '../../canvas/EditorOptions';
import { EditorSession } from '../../canvas/EditorSession';
import { RelativeTo } from '../../canvas/entities/Physical';
import { CanvasPing } from './Ping';
import { PingStore } from './PingStore';
import { Pingable } from './Pingable';

export class PingMechanics extends ActiveObject {

    @resolve(ObjectManager) private objects: ObjectManager;
    @resolve(EditorOptions) private options: EditorOptions;
    @resolve(EditorSession) private session: EditorSession;
    @resolve(PingStore) private store: PingStore;
    @resolve(CommandDispatcher) private dispatch: CommandDispatcher;

    private lastMousePos = null as Point;

    public start() {
        this.burden(
            listen(document.body, 'keydown', this.onGlobalKeyDown.bind(this)),
            listen(document.body, 'mousemove', this.onGlobalMouseMove.bind(this)),
        );

        this.initLocalPingOfCameraAutoTarget();
    }

    private initLocalPingOfCameraAutoTarget() {
        const instr = this.options.camera;
        if (instr?.startsWith('auto')) {
            const [_, target] = instr.split(':');
            const elmt = this.objects.getMaybe(target, Pingable);
            if (elmt) {
                const region = elmt.bounds(RelativeTo.Model).inflate(20);
                const ping = new CanvasPing(Colors.primary, region, 2000);
                this.store.add(ping);
            }
        }
    }

    private onGlobalMouseMove(e: MouseEvent) {
        this.lastMousePos = Point.from(e, 'client');
    }

    private onGlobalKeyDown(e: KeyboardEvent) {
        if (e.key === 'Tab' && this.lastMousePos) {
            const x = document.elementsFromPoint(this.lastMousePos.x, this.lastMousePos.y);

            for (const elmt of x) {
                const helmt = elmt as HTMLElement;
                if (!!elmt.id && elmt.id !== 'tool-layer' && helmt.dataset.tag === 'pingable') {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    this.dispatch('pingUI', [elmt.id]);
                    break;
                }
            }
        }
    }
}
